<!--
 * @Descripttion: 列
 * @Author: zenghua.wang
 * @Date: 2022-03-07 09:56:49
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-03-10 15:44:04
-->
<template>
  <!-- :filters="column.filters || config.column.filters"
    :filter-method="
    (value, row) => onFilterMethod(value, row, column.prop)
  " -->
  <el-table-column
    :prop="column.prop"
    :label="column.label ? column.label : column.prop"
    :fixed="column.fixed || config.column.fixed"
    :width="column.width || config.column.width"
    :align="column.align || config.column.align"
    :sortable="column.sortable || config.column.sortable"
  >
    <template slot-scope="scope">
      <!-- 下拉、级联 -->
      <div
        v-if="['select','cascader'].includes(column.type)"
        :style="styleContent(column)"
        @click="setLink(column, scope.row)"
      >
        <el-popover
          v-if="column.contentPopover"
          placement="top"
          trigger="hover"
          :content="formatDictory(column, scope.row)"
        >
          <span slot="reference">{{ formatDictory(column, scope.row) }}</span>
        </el-popover>
        <template v-else>{{formatDictory(column, scope.row)}}</template>
      </div>

      <!-- 其他 -->
      <div
        v-else
        :style="styleContent(column)"
        @click="setLink(column, scope.row)"
      >
        <el-popover
          v-if="column.contentPopover"
          placement="top"
          trigger="hover"
          :content="scope.row[column.prop]"
        >
          <span slot="reference">{{ scope.row[column.prop] }}</span>
        </el-popover>
        <template v-else>{{ scope.row[column.prop] }}</template>
      </div>
    </template>
  </el-table-column>
</template>
<script>
import {
  setRowByRoute,
  isEmpty,
  getQueryArrByParams,
  getDictoryByEqual
} from '@/dragComponents/utils'

export default {
  name: 'report-column',
  props: {
    column: {
      type: Object
    },
    config: {
      type: Object
    }
  },
  computed: {
    styleContent() {
      return function(item) {
        return Object.assign(
          {
            width: '100%',
            textAlign: item.contentAlign,
            color: item.contentColor
          },
          (() => {
            if (item.isLink) {
              return {
                textDecoration: 'underline',
                cursor: 'pointer'
              }
            }
            return {}
          })(),
          (() => {
            if (item.contentPopover) {
              return {
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden'
              }
            }
            return {}
          })()
        )
      }
    }
  },
  methods: {
    // 筛选
    onFilterMethod(value, row, prop) {
      return row[prop] === value
    },
    // 字典解析
    formatDictory(item, row) {
      let text =
        getDictoryByEqual(item.dicData, row[item.prop]) || row[item.prop]
      return text
    },
    /**
     * 超链接
     * 备注：
     * 1.将路由里面的参数添加到row里面，解析url
     * 2.超链接参数不是${var}设置，通过新增参数实现
     */
    setLink(item, row) {
      if (!item.isLink) return
      let params = getQueryArrByParams(this.$route.query)
      row = setRowByRoute(params, row)
      let str = ''
      let len = item.urlParams.length
      let has = item.urlPath.includes('?')
      if (len > 0) {
        item.urlParams.forEach((url, index) => {
          str += `${url.name}=${row[url.key]}${index === len - 1 ? '' : '&'}`
        })
      }
      let url = encodeURI(item.urlPath + (has ? '&' : '?&') + str)
      if (isEmpty(url)) return
      window.open(url, '_blank')
    }
  }
}
</script>
